/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AzureApiStrictHttpResponse } from '../../azure-api-strict-http-response';
import { AzureApiRequestBuilder } from '../../azure-api-request-builder';

import { BooleanNullableResponseModel } from '../../models/boolean-nullable-response-model';
import { VendorAuctionWorksheetTakeTheDealDto } from '../../models/vendor-auction-worksheet-take-the-deal-dto';

export interface ApiVendorVendorAuctionSubmitDenyDealPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorAuctionWorksheetTakeTheDealDto
}

export function apiVendorVendorAuctionSubmitDenyDealPost(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionSubmitDenyDealPost$Params, context?: HttpContext): Observable<AzureApiStrictHttpResponse<BooleanNullableResponseModel>> {
  const rb = new AzureApiRequestBuilder(rootUrl, apiVendorVendorAuctionSubmitDenyDealPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AzureApiStrictHttpResponse<BooleanNullableResponseModel>;
    })
  );
}

apiVendorVendorAuctionSubmitDenyDealPost.PATH = '/api/vendor/vendor-auction/SubmitDenyDeal';
